import {Component, OnInit} from '@angular/core';
import {TipoProducto} from '../../../models/tipo-producto.model';
import {CatalogosService} from '../../../services/catalogos.service';

@Component({
  templateUrl: './listado-analisis-laboratorio.component.html',
  styleUrls: ['./listado-analisis-laboratorio.component.css']
})
export class ListaAnalisisLaboratoriosComponent implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'Analisis de Laboratorio',
      routerLink: '/laboratorios'
    }
  ];

  tipos: TipoProducto[];
  loading = false;

  constructor(private catalogosService: CatalogosService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposAnalisisLaboratorios().subscribe((tipos) => {
      this.loading = false;
      this.tipos = tipos;
    });
  }
}
